// extracted by mini-css-extract-plugin
export default {"news_articles":"NewsArticles_news_articles__6BFns","news_articles_container":"NewsArticles_news_articles_container__6AIs4"};